import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import format from 'date-fns/format';
import * as fecha from 'fecha';
import DayPickerInputInner from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import { Form } from 'semantic-ui-react';
import isDate from 'lodash/isDate';

@observer
export default class DayPickerInput extends React.Component {
	props: {
		onDayChange: (day?: Date) => void,
		value: Date | '',
		formatDate?: (date: Date, frmt: string) => void,
		placeholder?: string,
		format?: string,
		parseDate?: (str: string, frmt: string) => Date,
		readOnly?: boolean,
		label?: string,
		width?: number,
		asFormField?: boolean,
		dayPickerProps?: any
	};

	static defaultProps = {
		formatDate: (date, frmt) => format(date, frmt),
		placeholder: 'DD/MM/YYYY',
		format: 'DD/MM/YYYY',
		parseDate: (str, frmt) => {
			try {
				return fecha.parse(str, frmt);
			} catch (e) {}
		},
		readOnly: false,
		asFormField: true
	};

	render() {
		const {
			onDayChange,
			value,
			formatDate,
			format,
			parseDate,
			placeholder,
			readOnly,
			label,
			width,
			asFormField,
			dayPickerProps
		} = this.props;
		let fieldProps = {};
		if (width) {
			fieldProps.width = width;
		}
		if (dayPickerProps) {
			fieldProps.dayPickerProps = dayPickerProps;
		}

		if (readOnly) {
			return (
				<Form.Input
					label={label}
					value={isDate(value) ? value.format() : ''}
					readOnly
					{...fieldProps}
				/>
			);
		} else {
			return asFormField ? (
				<Form.Field {...fieldProps}>
					<label>{label}</label>
					<DayPickerInputInner
						onDayChange={onDayChange}
						value={value}
						formatDate={formatDate}
						placeholder={placeholder}
						format={format}
						parseDate={parseDate}
					/>
				</Form.Field>
			) : (
				<DayPickerInputInner
					onDayChange={onDayChange}
					value={value}
					formatDate={formatDate}
					placeholder={placeholder}
					format={format}
					parseDate={parseDate}
					{...fieldProps}
				/>
			);
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/DayPickerInput/index.js